import React from 'react';
import {FolderParentName, LocalesOnFolder, ParentLocalesWrapper} from './AdvancedLocalePicker.style';
import {t} from 'i18next';
import {join} from 'lodash';

export interface ParentLocalesProps {
    readonly parentLocales: string[]
}

/**
 * @name ParentLocales
 * @description
 * Component to render inherited locales from parent item
 */
export const ParentLocales: React.VFC<ParentLocalesProps> = (props) => {
    return (
        <ParentLocalesWrapper>
            <FolderParentName>{`${t('CREATE_EDIT_FOLDER_DIALOG_POSSIBLE_LOCALES')}: `}</FolderParentName>
            <LocalesOnFolder>{join(props.parentLocales, ',  ')}
            </LocalesOnFolder>
        </ParentLocalesWrapper>
    );
};